import { render } from "./AdminThemes.vue?vue&type=template&id=5ea43b68"
import script from "./AdminThemes.vue?vue&type=script&lang=js"
export * from "./AdminThemes.vue?vue&type=script&lang=js"

import exportComponent from "/Users/michelnussbaum/Documents/WS/luisvue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__